import { CaregiverWithAssignedFamilyData } from '../../../types/caregivers';
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { CARE_GIVERS_TABLE_COLS, SUGGESTED_CAREGIVERS_TABLE_COLS } from '../../../constants/tables';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ts2Age } from '../../../helpers/utils';
import theme from '../../theme';
import TextButton from '../common/TextButton';
import Typography from '../common/Typography';
import { ERROR_COLOR_THEME, SUCCESS_COLOR_THEME } from '../../theme/palette';

interface Props {
  className?: string;
  data: CaregiverWithAssignedFamilyData[];
  onSelect: (c: CaregiverWithAssignedFamilyData) => void;
}

const Dot = ({
  on
}: {
  on: boolean;
}) => {
  return (
    <div
      style={{
        width: '16px',
        height: '16px',
        borderRadius: '16px',
        backgroundColor: on ? SUCCESS_COLOR_THEME : ERROR_COLOR_THEME, 
      }} />
  )
}

export default function SuggestedCaregiversTable({
  data,
  className,
  onSelect,
}: Props) {

  return (
    <Table
      removeWrapper
      className={className} 
      isStriped aria-label="Famiglie">
      <TableHeader>
        {SUGGESTED_CAREGIVERS_TABLE_COLS.map((c, i) => (
          <TableColumn key={i}>{c}</TableColumn>
        ))}
      </TableHeader>
      <TableBody>
        {
          data.map((caregiver, i) => (
            <TableRow key={i}>
              <TableCell>
                <div style={{display: 'flex', alignItems: 'center', gap: theme.sizing.x2}}>
                  <Dot on={!!!caregiver.assignedTo} />
                  <Typography variant='label'>{caregiver.personalData.surname}</Typography>
                </div>
              </TableCell>
              <TableCell><Typography variant='label'>{caregiver.personalData.name}</Typography></TableCell>
              <TableCell><Typography variant='label'>{ts2Age(caregiver.personalData.tsDateOfBirth).toString()}</Typography></TableCell>
              <TableCell><Typography variant='label'>{caregiver.personalData.nationality}</Typography></TableCell>
              <TableCell><Typography variant='label'>{caregiver.personalData.address}</Typography></TableCell>
              <TableCell className='max-w-20'>
                <div className="items-center">
                  <Tooltip content="Vedi">
                    <TextButton 
                      title='SELEZIONA'
                      onPress={() => onSelect(caregiver)} />
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          ))
        }
      </TableBody>
    </Table>
  )
}